
















import { createComponent } from "@vue/composition-api";
import { useDictionary } from "@dcc/views/compositions/useDictionary";
import {
  TERMS_AND_CONDITIONS_LINK,
  PRIVACY_POLICY_LINK
} from "@dcc/constants/links";

export default createComponent({
  setup() {
    const dictionary = useDictionary();

    return {
      ...dictionary,
      TERMS_AND_CONDITIONS_LINK,
      PRIVACY_POLICY_LINK
    };
  }
});
